import { Outlet, useLocation } from "react-router-dom";

export default function SettingPage(): JSX.Element {
  const outletContext = {};
  return <Outlet context={outletContext} />;
}
